import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '@/lib/firebase';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';

export const Login: React.FC = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate('/admin');
        } catch (err: any) {
            setError(err.message);
        }
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-bg-subtle p-6 animate-fade-in">
            <div className="card-elegant w-full max-w-md">
                <div className="text-center mb-8">
                    <p className="eyebrow mb-2">Backstage</p>
                    <h1 className="text-3xl font-serif text-secondary">Admin Login</h1>
                </div>

                <form onSubmit={handleLogin} className="space-y-6">
                    {error && (
                        <div className="p-3 bg-red-50 text-red-600 text-base rounded-xl border border-red-100 italic">
                            {error}
                        </div>
                    )}
                    <div className="space-y-1.5">
                        <label className="block text-sm font-black uppercase tracking-widest text-secondary-light ml-1">Email</label>
                        <input
                            type="email"
                            className="input-wedding"
                            placeholder="admin@laboda.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="space-y-1.5">
                        <label className="block text-sm font-black uppercase tracking-widest text-secondary-light ml-1">Password</label>
                        <input
                            type="password"
                            className="input-wedding"
                            placeholder="••••••••"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <Button type="submit" fullWidth size="lg">Sign In</Button>
                </form>
            </div>
            <button onClick={() => navigate('/')} className="mt-8 text-secondary-light/60 hover:text-primary text-sm font-black uppercase tracking-widest transition-colors">
                Back to Wedding
            </button>
        </div>
    );
};
